
<template>
    <div class="embedded">
        <h2>Stand der Dinge, Augenringe:</h2>
        <div class="logo">
            <a href="https://www.krebsgesellschaftnrw.de/">
                <img src="https://www.krebsgesellschaftnrw.de/wp-content/uploads/2021/12/logo-1024x178.png" width="150px"/>
            </a>
            <a href="https://kilometergegenkrebs.de/app/#">
                <img src="https://kilometergegenkrebs.de/wp-content/uploads/2020/03/LogoKMgKweiss-1024x256.png" width="170px" style="filter:invert(100%);"/>
            </a>
        </div>
        <GlobalProgressEmbed />
    </div>
</template>


<script>
// @ is an alias to /src
import GlobalProgressEmbed from '../components/GlobalProgressEmbed.vue';

export default {
  name: 'embedded',
  components: {
    GlobalProgressEmbed,
  },
  data() {
    return {
        baseUrl: window.baseroute
    }
  }
}
</script>

<style lang="scss" scoped>
    .embedded-progress h2 {
        font-size:14px;
        display: inline-block;
        width: 100%;
        margin-bottom: 2px;
        margin-top: 2px;
        font-family: Verdana, Geneva, Tahoma, sans-serif;
    }
    .embedded-progress .logo {
        display: inline-block;
        width: 100px;
        vertical-align: top;
    }
    .embedded-progress {
        display: inline-block;
        width: 150px;
    }
    .embedded-progress .vue-circular-progress > h3 {
        margin-bottom:0!important;
    }


    .kgk-embed h2{
        font-size:12px;
        margin:2px;
        margin-bottom: 10px;
    }
    .kgk-embed .logo {
        
        width: 130px;
        display: inline-block;
        vertical-align: top;
    }

</style>